<template>
  <div>
    <div class="type-title">價格清單</div>
    <div class="cell-list">
      <CellItem class="cell-wrap" :textLeft="priceText" textRight="" :textLight="!!skillInfo.price" @active="toSetPrice" />
      <CellItem
        v-for="(p, i) in skillInfo.skillPriceList"
        :key="'more-price-' + i"
        class="cell-wrap"
        :textLeft="p.name"
        :textRight="parseMoreText(p.price, p.salesUnit)"
        @active="toSetMorePrice(i)"
      />
      <CellItem v-if="skillInfo.price && skillInfo.skillPriceList.length<7" class="cell-wrap" textLeft="添加自定義價格（選填）" textRight="" :textLight="false" @active="toSetMorePrice()" />
    </div>
    <el-dialog
      :visible="selectPrice"
      class="dialog-set-skill-wrap"
      custom-class="dialog-clear-style dialog-set-skill"
      :append-to-body="true"
      :show-close="false"
    >
      <div class="dialog-wrap">
        <div class="dialog-title">
          <span>價格設定</span>
          <fps-icon class="pointer" type="close" size="24" @click.native="selectPrice = false" />
        </div>
        <div class="dialog-content">
          <div v-if="gameInfo.meanPrice" class="tip-text">該技能平均定價：${{ gameInfo.meanPrice }}/{{ gameInfo.salesUnit | salesUnitTranslate }}</div>
          <div class="set-price">
            <div class="price">
              <div>
                <input type="number" v-model="editingSkillPrice" @change="inputNumber" placeholder="價格">
              </div>
            </div>
            <el-popover
              placement="bottom"
              width="172"
              v-model="showSelectUnit"
              class="select-unit"
              :visible-arrow="false"
              popper-class="popper-clear-style"
            >
              <div class="select-unit-wrap">
                <div
                  v-for="(s, i) in (gameInfo.freeMarket ? gameInfo.salesUnitList : [gameInfo.salesUnit])"
                  :key="'unit-' + i"
                  class="one-unit"
                  @click="toSelectUnit(s)"
                >
                  {{ s | salesUnitTranslate }}
                </div>
              </div>
              <div slot="reference" class="unit-button pointer">
                <span v-if="editingSkillUnit">{{ editingSkillUnit | salesUnitTranslate }}</span>
                <span v-else class="no-unit">選擇計價單位</span>
                <img :class="showSelectUnit && 'active'" src="~@/assets/image/icons/arrow-bottom-gray.png">
              </div>
            </el-popover>
          </div>
          <div class="footer">
            <button class="primary-btn" @click="updatePrice">
              <span>確認</span>
            </button>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible="showMorePrice"
      class="dialog-set-skill-wrap"
      custom-class="dialog-clear-style dialog-set-skill"
      :append-to-body="true"
      :show-close="false"
    >
      <div class="dialog-wrap">
        <div class="dialog-title">
          <span>價格設定</span>
          <fps-icon class="pointer" type="close" size="24" @click.native="showMorePrice = false" />
        </div>
        <div class="dialog-content" v-if="showConfimDayPrice">
          <div class="tip-text">您當前設置的技能單位為：</div>
          <div style="color: #222C43;
    font-size: 36px;
    text-align: center;">$ {{settingMorePrice.price}} /天</div>
          <div style="color:#E63B37">請核實價格是否準確，並與用戶商議陪玩時長，後續因為價格單位設置引起的訂單糾紛由陪玩師自行承擔</div>
          <div class="footer">
            <button class="" style="margin-right:10px;" @click="updateMorePrice(1)">
              <span>再想想</span>
            </button>
            <button class="primary-btn" @click="updateMorePrice(2)">
              <span>確認</span>
            </button>
          </div>
        </div>
        <div class="dialog-content" v-else>
          <div class="tip-text"><span>價格</span></div>
          <div class="set-price">
            <div class="price">
              <div>
                <input type="number" v-model="settingMorePrice.price" @change="inputNumber2" placeholder="價格">
              </div>
            </div>
            <el-popover
              placement="bottom"
              width="172"
              v-model="showSelectUnit2"
              class="select-unit"
              :visible-arrow="false"
              popper-class="popper-clear-style"
            >
              <div class="select-unit-wrap">
                <div
                  v-for="(s, i) in gameInfo.salesUnitList"
                  :key="'unit-' + i"
                  class="one-unit"
                  @click="toSelectMoreUnit(s)"
                >
                  {{ s | salesUnitTranslate }}
                </div>
              </div>
              <div slot="reference" class="unit-button pointer">
                <span v-if="settingMorePrice.salesUnit">{{ settingMorePrice.salesUnit | salesUnitTranslate }}</span>
                <span v-else class="no-unit">選擇計價單位</span>
                <img :class="showSelectUnit2 && 'active'" src="~@/assets/image/icons/arrow-bottom-gray.png">
              </div>
            </el-popover>
          </div>
          <div v-if="settingMorePrice.salesUnit=='Minutes7'" class="tip-text">模式（單位為7分鐘，模式默認為7分鐘嚐鮮）</div>
          <div v-else-if="showNameInput" class="tip-text">例：單位選擇局，設定輸入為積分模式，則價格設定為積 分模式100幣/局(內容不超過8個字符）</div>
          <div v-else class="tip-text">
            <span>模式</span><span v-if="!notHourLOL">(單位為小時，模式不可選擇)</span>
            <span v-if="settingMorePrice.name && havenotName && notHourLOL" class="error-text">模式名稱不符合標準，請重新設定</span>
            <span v-if="settingMorePrice.name && nameNotMatch" class="error-text">模式名稱不符合標準，已重新設定</span>
          </div>
          <div v-if="showNameInput" class="input-model-name">
            <input type="text" v-model="settingMorePrice.name" maxlength="8" placeholder="設定模式名稱">
          </div>
          <div v-else class="input-model-name">
            <el-popover
              placement="bottom"
              width="360"
              v-model="showSelectModel"
              class="select-unit"
              :visible-arrow="false"
              popper-class="popper-clear-style"
              :disabled="settingMorePrice.salesUnit=='Day'"
            >
              <div class="select-unit-wrap">
                <div
                  v-for="(s, i) in gameInfo.gameModelList"
                  :key="'model-' + i"
                  class="one-unit"
                  @click="toSelectModel(s)"
                >
                  {{ s.name }}
                </div>
              </div>
              <div slot="reference" class="unit-button pointer" @click="notHourLOL || (showSelectModel = !showSelectModel)">
                <span v-if="settingMorePrice.name">{{ settingMorePrice.name }}</span>
                <span v-else class="no-unit">設定模式</span>
                <img v-if="notHourLOL" :class="showSelectModel && 'active'" src="~@/assets/image/icons/arrow-bottom-gray.png">
              </div>
            </el-popover>
          </div>
          <div v-if="customError" class="tip-text">
            <span class="error-text">{{customError}}</span>
          </div>
          <div class="footer">
            <button v-show="isEditing" class="default-button" @click="deleteMorePrice">
              <span>刪除價格</span>
            </button>
            <button class="primary-btn" @click="updateMorePrice">
              <span>確認</span>
            </button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import CellItem from './cells'
import { salesUnitTranslate } from '@/filters/index'
export default {
  components: {
    CellItem,
  },
  props: {
    skillInfo: Object,
    gameInfo: Object,
  },
  data() {
    return {
      selectPrice: false,
      editingSkillPrice: '',
      editingSkillUnit: '',
      showSelectUnit: false,
      showSelectUnit2: false,
      settingMorePrice: {},
      showMorePrice: false,
      showSelectModel: false,
      isEditing: false,
      nameNotMatch: false,
      showConfimDayPrice: false,
      customError: '',
    }
  },
  computed: {
    priceText() {
      const { price, salesUnit } = this.skillInfo
      if (price) {
        return `${price}幣/${ salesUnitTranslate(salesUnit) }`
      } else {
        return '暫未設置'
      }
    },
    notHourLOL() {
      return (this.gameInfo.id !== 1 && this.gameInfo.id !== 125) || this.settingMorePrice.salesUnit !== 'Hour'
    },
    showNameInput() {
      return !(this.gameInfo && this.gameInfo.gameModelList && this.gameInfo.gameModelList.length)
    },
    havenotName() {
      if (this.gameInfo && this.gameInfo.gameModelList) {
        return !this.gameInfo.gameModelList.some(item => item.name === this.settingMorePrice.name)
      }
      return false
    },
  },
  created() {
    const pre = sessionStorage.getItem('preSetPrice')
    if (pre) {
      this.showMorePrice = true
      this.settingMorePrice = JSON.parse(pre)
      this.isEditing = false
      this.settingMoreIndex = -1
      sessionStorage.removeItem('preSetPrice')
    }
  },
  methods: {
    inputNumber() {
      const parseNumber = parseInt(this.editingSkillPrice)
      if (this.editingSkillPrice != parseNumber) {
        this.editingSkillPrice = parseNumber
      }
    },
    toSelectModel({ name, id }) {
      this.$set(this.settingMorePrice, 'name', name)
      this.$set(this.settingMorePrice, 'gameModelId', id)
      this.showSelectModel = false
    },
    inputNumber2() {
      const parseNumber = parseInt(this.settingMorePrice.price)
      if (this.settingMorePrice.price != parseNumber) {
        this.settingMorePrice.price = parseNumber
      }
    },
    parseMoreText(price, salesUnit) {
      return `${price}幣/${ salesUnitTranslate(salesUnit) }`
    },
    toSelectUnit(s) {
      this.editingSkillUnit = s
      this.showSelectUnit = false
    },
    toSelectMoreUnit(s) {
      this.nameNotMatch = false;
      this.customError = '';
      if(s == 'Minutes7'){
        this.$set(this.settingMorePrice, 'name', '7分鐘嚐鮮')
        if (this.settingMorePrice.price < 30 || this.settingMorePrice.price > 40) {
          this.settingMorePrice.price = '';
          this.customError = '極速體驗價格設定區間僅為30-40nicee幣，請重新設置';
        }
      }else{
        this.$set(this.settingMorePrice, 'name', '')
      }
      if (s === 'Day') {
        if(this.settingMorePrice.name && this.settingMorePrice.name !== '不限'){
          this.nameNotMatch = true;
        }
        this.$set(this.settingMorePrice, 'name', '不限')
      }
      if (this.settingMorePrice.salesUnit === s) {
        this.showSelectUnit2 = false
        return
      }
      if (this.gameInfo.id === 1 || this.gameInfo.id === 125) {
        if (this.settingMorePrice.salesUnit === 'Hour') {
          this.toSelectModel(this.confirmModelObj || { id: '', name: '' })
        } else if (s === 'Hour') {
          this.confirmModelObj = {
            name: this.settingMorePrice.name,
            id: this.settingMorePrice.gameModelId,
          }
          this.$set(this.settingMorePrice, 'name', '不限模式')
          this.$set(this.settingMorePrice, 'gameModelId', '')
        }
      }
      this.$set(this.settingMorePrice, 'salesUnit', s)
      this.showSelectUnit2 = false
    },
    updatePrice() {
      const { editingSkillPrice, editingSkillUnit, gameInfo: { priceLeft, priceRight } } = this
      if (!editingSkillPrice) {
        this.$message('請設置價格')
        return
      }
      if (!editingSkillUnit) {
        this.$message('請設置單位')
        return
      }
      if (editingSkillPrice < priceLeft || editingSkillPrice > priceRight) {
        this.$message(`價格必須在${priceLeft}-${priceRight}之間喔`)
        return
      }
      this.$emit('setSkillInfo', { price: editingSkillPrice, salesUnit: editingSkillUnit })
      this.selectPrice = false
    },
    toSetPrice() {
      this.editingSkillPrice = this.skillInfo.price || ''
      if (this.gameInfo.freeMarket) {
        this.editingSkillUnit = this.skillInfo.salesUnit
      } else {
        this.editingSkillUnit = this.gameInfo.salesUnit
      }
      this.selectPrice = true
    },
    toSetMorePrice(i = -1) {
      this.settingMoreIndex = i
      if (i === -1) {
        this.settingMorePrice = {}
        this.isEditing = false
        this.customError = '';
      } else {
        this.settingMorePrice = { ...this.skillInfo.skillPriceList[i] }
        if (!this.notHourLOL) {
          this.$set(this.settingMorePrice, 'name', '不限模式')
          this.$set(this.settingMorePrice, 'gameModelId', '')
        }
        this.isEditing = true
      }
      this.showMorePrice = true
    },
    deleteMorePrice() {
      const { skillPriceList } = this.skillInfo
      skillPriceList.splice(this.settingMoreIndex, 1)
      this.$emit('setSkillInfo', {
        skillPriceList
      })
      this.showMorePrice = false
    },
    updateMorePrice(code) {
      if (code == 1) {
        this.showConfimDayPrice = false;
        return;
      }
      if (code != 2 && this.settingMorePrice.salesUnit == 'Day') {
        this.showConfimDayPrice = true;
        return;
      }
      this.showConfimDayPrice = false;
      const { settingMorePrice, gameInfo: { priceLeft, priceRight, gameModelList }, havenotName } = this
      const { price, salesUnit, name, id } = settingMorePrice
      if (!price) {
        this.$message('請設置價格')
        return
      }
      if (this.settingMorePrice.salesUnit == 'Minutes7') {
        if (price < 30 || price > 40) {
          this.$message(`價格必須在30-40之間喔`)
          return
        }
      }
      else if (price < priceLeft || price > priceRight) {
        this.$message(`價格必須在${priceLeft}-${priceRight}之間喔`)
        return
      }
      if (!name && this.notHourLOL) {
        this.$message('請設置模式名稱')
        return
      }
      if (this.notHourLOL && gameModelList && gameModelList.length && havenotName) {
        this.$message('模式名稱不符合標準，請重新設定')
        return
      }
      if (!salesUnit) {
        this.$message('請設置單位')
        return
      }
      if (this.skillInfo.skillPriceList.some(item => (item.name === name && item.salesUnit === salesUnit && (id !== item.id || (!id && !item.id))))) {
        this.$message('計價單位模式重複設定')
        return
      }
      const skillPriceList = [...this.skillInfo.skillPriceList]
      if (this.settingMoreIndex === -1) {
        skillPriceList.push(this.settingMorePrice)
      } else {
        skillPriceList.splice(this.settingMoreIndex, 1, this.settingMorePrice)
      }
      this.$emit('setSkillInfo', {
        skillPriceList
      })
      this.showMorePrice = false
    },
  }
}
</script>
<style lang="scss" scoped>
  input {
    height: 40px;
    box-sizing: border-box;
    border: 1px solid #999999;
    border-radius: 4px;
    padding-left: 12px;

    &:focus {
      border: none;
      box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.2);
      padding-left: 13px;
    }
    &::-ms-input-placeholder {
      color: $color-gray-2;
    }
    &::-webkit-input-placeholder {
      color: $color-gray-2;
    }
    &::-o-input-placeholder {
      color: $color-gray-2;
    }
    &::-moz-input-placeholder {
      color: $color-gray-2;
    }
  }
  .select-unit-wrap {
    background: #fff;
    border-radius: 8px;
    filter: drop-shadow(0px 2px 24px rgba(0, 0, 0, 0.1));
    .one-unit {
      cursor: pointer;
      font-weight: 500;
      font-size: 14px;
      height: 38px;
      line-height: 38px;
      text-align: center;
      color: #333333;
      &:hover {
        background: #f6f6f6;
      }
    }
  }
  .dialog-set-skill-wrap /deep/ .dialog-set-skill {
    width: 420px;
  }
  .dialog-set-skill-wrap /deep/ .dialog-wrap {
    background: #FFFFFF;
    border-radius: 8px;
    width: 420px;
    .dialog-title {
      @include flex(space-between);
      font-weight: 500;
      font-size: 18px;
      line-height: 25px;
      color: $color-gray-1;
      border-bottom: 1px solid #E0E0E0;
      height: 64px;
      padding: 0 18px 0 30px;
    }
    .dialog-content {
      padding: 16px 30px 30px;
      .tip-text {
        font-size: 14px;
        line-height: 20px;
        color: $color-gray-3;
        @include flex(flex-start);
        .error-text {
          color: $color-red;
          margin-left: 12px;
        }
      }
      .set-price {
        @include flex();
        position: relative;

        .price {
          position: relative;
          flex: 1;
          height: 40px;
          font-size: 14px;
          font-weight: 500;
          line-height: 22px;

          span {
            position: absolute;
            left: 12px;
            top: 9px;
          }

          input {
            height: 40px;
            box-sizing: border-box;
            border: 1px solid #999999;
            border-radius: 4px;
            padding-left: 12px;
            font-size: 14px;

            &:focus {
              border: none;
              box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.2);
              padding-left: 13px;
            }
            &::-ms-input-placeholder {
              color: $color-gray-2;
              font-size: 14px;
            }
            &::-webkit-input-placeholder {
              color: $color-gray-2;
              font-size: 14px;
            }
            &::-o-input-placeholder {
              color: $color-gray-2;
              font-size: 14px;
            }
            &::-moz-input-placeholder {
              color: $color-gray-2;
              font-size: 14px;
            }
          }

          .error-line {
            font-size: 12px;
            line-height: 17px;
            font-weight: 500;
            color: #FD2243;
            margin-top: 4px;
          }
        }
        .select-unit {
          margin-left: 16px;
          flex: 1;
        }
      }
      .unit-button {
        height: 40px;
        background: #FFFFFF;
        border: 1px solid #999999;
        box-sizing: border-box;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 15px 0 9px;
        font-size: 14px;
        line-height: 20px;
        color: $color-gray-1;
        .no-unit {
          color: $color-gray-2;
        }
        img {
          width: 10px;
          transition: all .3s;
          &.active {
            transform: rotate(180deg);
          }
        }
      }
      &>div:not(:first-child) {
        margin-top: 16px;
      }
      .input-model-name {
        input {
          width: 100%;
          font-size: 14px;
          &::placeholder {
            font-size: 14px;
            color: $color-gray-2;
          }
        }
      }
      .footer {
        @include flex(flex-end);
        margin-top: 28px;

        button {
          width: 100px;
          height: 40px;
        }
        .default-button {
          background: $color-button;
          border-radius: 4px;
          font-weight: 500;
          font-size: 14px;
          line-height: 40px;
          text-align: center;
          color: $color-gray-2;
          margin-right: 20px;
        }
      }
    }
  }
  .type-title {
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: $color-gray-1;
    margin-top: 30px;
  }
  .cell-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .cell-wrap {
      width: 435px;
      height: 62px;
      margin: 10px 0;
      &:nth-child(odd) {
        margin-right: 28px;
      }
    }
  }
</style>
